import React from 'react';

const ComingSoonBadge = () => {
  return (
    <svg width="150" height="30" viewBox="0 0 150 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#e53935" />
          <stop offset="100%" stopColor="#43a047" />
        </linearGradient>
      </defs>
      <rect x="1.5" y="1.5" width="147" height="27" rx="6" stroke="url(#grad1)" strokeWidth="2" fill="transparent"/>
      <text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fill="url(#grad1)" fontSize="13" fontWeight="900" fontFamily="Arial, sans-serif" letterSpacing="0.5">
        СКОРО ОТКРЫТИЕ
      </text>
    </svg>
  );
};

export default ComingSoonBadge;
